module.exports = __webpack_public_path__ + "img/rjgx.c83e5045.png";